import React from 'react';
import { Editor } from 'primereact/editor';
import { EDITOR_MODULES, persistFormatAcrossNewline } from './TextEditor.constants';
import './TextEditor.css';
import { TextEditorHeader } from './TextEditorHeader';

export const TextEditor = ({ value, onTextChange }) => {
  return (
    <Editor
      className="editor"
      value={value}
      onTextChange={onTextChange}
      headerTemplate={<TextEditorHeader />}
      modules={EDITOR_MODULES}
      onLoad={persistFormatAcrossNewline}
    />
  );
};
